import type { MouseEvent } from "react";
import { useTranslate } from "ra-core";
import { ExternalLink } from "lucide-react";

import { useIsMobile } from "@/hooks/use-mobile";
import type { BCInteractionLog } from "../types";

export const getBcInteractionDeepLink = (
  interaction: Pick<BCInteractionLog, "web_deep_link" | "app_deep_link">,
  isMobile: boolean,
): string | undefined => {
  if (isMobile) {
    return interaction.app_deep_link ?? interaction.web_deep_link ?? undefined;
  }
  return interaction.web_deep_link ?? interaction.app_deep_link ?? undefined;
};

export const BCInteractionDeepLink = ({
  interaction,
  className,
  onClick,
}: {
  interaction: Pick<BCInteractionLog, "web_deep_link" | "app_deep_link">;
  className?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}) => {
  const isMobile = useIsMobile();
  const translate = useTranslate();
  const href = getBcInteractionDeepLink(interaction, isMobile);

  if (!href) return null;

  const isAppLink = href.startsWith("ms-businesscentral://");
  const label = translate("resources.bc_interaction_log.open_in_bc", {
    _: "Open in Business Central",
  });

  return (
    <a
      href={href}
      className={className}
      onClick={onClick}
      title={label}
      aria-label={label}
      {...(isAppLink
        ? {}
        : { target: "_blank", rel: "noopener noreferrer" })}
    >
      <ExternalLink className="h-4 w-4" />
    </a>
  );
};
